import Navbar from "../components/Navbar";
import HomeHero from "../components/views/home/HomeHero";
import HomeProcess from "../components/views/home/HomeProcess";
import HomeShowcase from "../components/views/home/HomeShowcase";
import HomePhilosophy from "../components/views/home/HomePhilosophy";
import HomeFeatures from "../components/views/home/HomeFeatures";
import HomePricing from "../components/views/home/HomePricing";
import HomeTestimonials from "../components/views/home/HomeTestimonials";
import HomeFooter from "../components/views/home/HomeFooter";

const StylistgptLandingPage = () => {
  return (
    <>
      <Navbar />
      <div className="bg-gradient-to-br from-slate-50 via-white to-pink-50 text-gray-900 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900 dark:text-white overflow-hidden">
        <HomeHero />
        <HomePricing />
        <HomeProcess />
        <HomeShowcase />
        <HomePhilosophy />
        <HomeFeatures />
        <HomeTestimonials />
        <HomeFooter />
      </div>
    </>
  );
};

export default StylistgptLandingPage;
